// Web module: evidence. Evidence Library (L1 compliance core). Entities: evidence_item, evidence_version, file.
//   /evidence            EvidenceLibraryPage: status groups, banner, filters, search by name or control, bulk owner, CSV
//   /evidence/:id        generic detail page plus Artifacts (current and past, add new artifact, view and download)
//                        and Linked controls tabs
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    evidence_item: {
      ListPage: lazyComponent(() => import('./EvidenceLibraryPage'), 'EvidenceLibraryPage'),
      detailTabs: [
        {
          id: 'artifacts',
          label: 'Artifacts',
          order: 12,
          component: lazyComponent(() => import('./EvidenceTabs'), 'ArtifactsTab'),
        },
        {
          id: 'controls',
          label: 'Linked controls',
          order: 20,
          component: lazyComponent(() => import('./EvidenceTabs'), 'LinkedControlsTab'),
        },
      ],
      hideDefaultTabs: ['links'],
    },
  },
}
